<template>
  <ToolGroupBtn
    icon="fa-square fa-light"
    :callback="setToolActive"
    :active="isToolActive"
    :title="$t('wwwc')"
    :deselect="true"
    :disable-select="studySC"
  >
    <a-popover :title="false" trigger="click">
      <template slot="content">
        <a-list item-layout="horizontal" :data-source="presets">
          <a-list-item
            slot="renderItem"
            slot-scope="preset"
            @click="setWwwcLevel(preset)"
            v-bind:class="{
              'ant-list-item__active': activePreset === preset.id,
            }"
          >
            <div>
              <span class="dash-text__600 m-r">{{
                preset.id + " - " + preset.title
              }}</span>
              <span class="dash-text__12 dash-text__400 v-a-b">{{
                preset.value
              }}</span>
            </div>
          </a-list-item>
        </a-list>
      </template>
      <div class="tool-group-btn__item tool-group-btn__arrow">
        <i class="fa fa-solid fa-chevron-down"></i>
      </div>
    </a-popover>
  </ToolGroupBtn>
</template>

<script>
import { mapGetters } from "vuex";

import ToolGroupBtn from "./ToolGroupBtn";

export default {
  components: {
    ToolGroupBtn,
  },
  data() {
    return {
      activePreset: undefined,
      studySC: false,
    };
  },
  beforeDestroy() {
    this.$root.$off("resetPreset", this.resetPreset);
    this.$root.$off("newActiveCanvas", this.setActiveStudySC);
  },
  created() {
    this.$accessModule("wwwc_tool", this);
  },
  mounted() {
    this.$root.$on("resetPreset", this.resetPreset);
    this.$root.$on("newActiveCanvas", this.setActiveStudySC);
  },
  computed: {
    ...mapGetters(["activeTools", "presets", "seriesList"]),
    isToolActive() {
      return this.activeTools.indexOf("WindowLevel") !== -1;
    },
  },
  watch: {
    studySC(val) {
      this.$debug(
        "Выбранное в активном окне исследование " +
          (!val ? "НЕ" : "") +
          " является SC. " +
          (val ? "НЕ" : "") +
          " доступны пресеты",
        "warning"
      );
    },
  },
  methods: {
    setActiveStudySC(canvas) {
      const serie = this.$_.findWhere(this.seriesList, {
        seriesInstanceUid: canvas.serie_id,
      });
      this.studySC = serie ? !!serie.ai : false;
    },
    resetPreset() {
      this.activePreset = undefined;
    },
    setWwwcLevel(preset) {
      if (!preset.voi) {
        this.$root.$emit("resetWindowLevel");
        this.resetPreset();
        return;
      }
      this.$root.$emit("setWwwcLevel", preset);
      this.activePreset = preset.id;
      if (!this.isToolActive) {
        this.setToolActive();
      }
    },
    setToolActive() {
      this.$store.dispatch(
        "updateActiveTools",
        this.isToolActive
          ? this.activeTools.filter((tool) => {
              return tool !== "WindowLevel" || tool !== "Wwwc";
            })
          : this.activeTools
              .filter((tool) => {
                return tool === "StackScrollMouseWheel";
              })
              .concat(["WindowLevel", "Wwwc"])
      );
    },
  },
};
</script>
